<template>
    <div class="card-exchange-container">
        <div class="header-title-div">
            <div class="header-left-img-div" @click="confirmToPage()">
                <img class="header-back-img" src="../../../assets/h5-img/back.png" width="18" />
            </div>
            <div class="header-title">兑换</div>
        </div>
        <div class="exchange-form-div">
            <div class="input-tips-div">
                
            </div>
            <div class="input-div">
                <input type="text" class="exchange-input" placeholder="请输入兑换码" v-model="exchangeCode">
            </div>
            <div class="confirm-submit-div">
                <button class="confirm-submit-btn" @click="validCardFun">提交</button>
            </div>
        </div>
        <div class="cover-full-bg-div" v-show="showSucModal">
            <div class="suc-modal-div">
                <div class="relative-full-div">
                    <div class="absolute-moadl-content-div">
                        <div class="suc-modal-tips-div margin-top-32">已成功兑换{{exchangeVal}}额度</div>
                        <div class="suc-modal-tips-div">可用于旗下电站抵扣</div>
                        <div class="confirm-btn-div">
                            <button class="confirm-page-btn-div" @click="confirmToPage">确认</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                exchangeCode: '', // 兑换码
                curUserPhone: '',
                showSucModal: false,
                exchangeVal: 0,
            }
        },
        methods: {
            init() {},
            validCardFun() {
                let _ = this;
                if (_.exchangeCode == '') {
                    _.$U.error('请输入兑换码');
                    return
                }
                const postInfo = {
                    corpNo: _.$C.corpNo,
                    userPhone: _.curUserPhone,
                    exchangeCode: _.exchangeCode
                };
                _.$U.showLoading(_);
                _.showSucModal = false;
                _.$H.post(_, _.$A.h5.exchangeCards, postInfo).then(res => {
                    const resData = res.data.data;
                    _.exchangeVal = resData.cardElectric || 0;
                    _.showSucModal = true;
                    _.$U.hideLoading(_);
                })
            },
            confirmToPage() {
                this.$store.commit('setCardDetailBack','Y')
                this.$router.replace({
                    name: 'h5_chargeCardList'
                })
            },
        },
        mounted() {
            const info = this.$store.state.curAppH5Info || {};
            this.curUserPhone = info.curUserPhone;
            this.init()
        },
    }
</script>

<style lang="less" scoped>
    .card-exchange-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .exchange-form-div {
        width: 100%;
        .input-tips-div {
            margin: 0 32px;
            line-height: 32px;
            font-size: 14px;
        }
        .input-div {
            margin: 0 32px;
        }
        .exchange-input {
            width: 100%;
        }
        .confirm-submit-div {
            margin: 16px 32px 0;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .exchange-input {
            border: 0;
            width: 328px;
            opacity: 1;
            background: #f4f4fb;
            border-radius: 13px;
            height: 40px;
            line-height: 40px;
            padding: 0 16px;
            font-size: 14px;
            color: #555;
            outline: none;
        }
        .exchange-input::placeholder{
            color: #BCBCC1;
        }
        .confirm-submit-btn {
            width: 240px;
            height: 45px;
            border: 0;
            line-height: 45px;
            font-size: 14px;
            color: #fff;
            background: #04b6b6;
            border-radius: 23px;
            outline: none;
        }
    }
    .cover-full-bg-div {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        background-color: #000000b3;
        .relative-full-div {
            width: 100%;
            height: 100%;
            position: relative;
        }
        .suc-modal-div {
            width: 100%;
            height: 100%;
        }
        .absolute-moadl-content-div {
            position: absolute;
            width: 300px;
            left: 50%;
            top: 30%;
            transform: translateX(-50%);
            height: 168px;
            background-color: #fff;
            border-radius: 10px;
            .suc-modal-tips-div {
                text-align: center;
                line-height: 32px;
                color: #04b6b6;
            }
            .confirm-btn-div {
                margin: 20px 32px;
            }
            .confirm-page-btn-div {
                width: 100%;
                height: 45px;
                border: 0;
                background: #04b6b6;
                border-radius: 23px;
                line-height: 45px;
                border-radius: 23px;
                color: #fff;
                outline: none;
            }
        }
        .margin-top-32 {
            margin-top: 24px;
        }
    }
    .header-title-div {
        height: 32px;
        display: flex;
        margin-top: 16px;
        position: fixed;
        top: 0;
        left: 0;
        .header-left-img-div {
            width: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 10px;
        }
        .header-title {
            flex: 1;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            line-height: 32px;
        }
        .header-right-get-title {
            flex: 1;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1ec577;
            line-height: 32px;
            margin-right: 12px;
            text-align: right;
        }
    }
</style>
